var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Listener',{staticClass:"create-page",attrs:{"data-test-id":"apps-create-page"}})
}
var staticRenderFns = []

export { render, staticRenderFns }